// extracted by mini-css-extract-plugin
export default {"pageLayout":"desktop_pageLayout__xkiy9","wrapper":"desktop_wrapper__EL4ka"};